<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular {{screenType}}"
>
  <div
    *ngIf="label"

    class="form-field-label {{type}} flex flex-row justify-between"
  >
    <div class="label flex flex-row content-center">
      {{ label }}
      <span
        *ngIf="isRequired"
        class="required-mark ml-[0.3rem]"
      >*</span>
      <app-icon
        *ngIf="tooltip"
        [matTooltip]="tooltipText"
        class="tooltip-icon"
        matTooltipClass="custom-tooltip"
        matTooltipPosition="below"
        svgIcon="info"
      ></app-icon>
    </div>
    <div
      (click)="redirect()"
      *ngIf="displayRedirectLink"
      class="link underline text-digital-blue-light">
      Forgot Password?
    </div>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    [ngClass]="type ? 'small' : ''"
    appearance="outline"
    class="form-field w-full"
    hideRequiredMarker
  >
    <input
      #input
      [class.show]="showPassword"
      [class.text-black-400]="isDisabled"
      [formControlName]="controlName"
      [maxlength]="maxLength"
      [minLength]="minLength"
      class="input {{type}} password-input"
      matInput
      placeholder="{{placeholder}}"
      type="text"
    >
    <div
      [class.empty]="!passwordLooper.length"
      [class.hide]="showPassword"
      class="overlay"
    >
      <span
        *ngIf="!passwordLooper.length"
        class="placeholder"

      >
        {{ placeholder }}
      </span>
      <app-icon
        *ngFor="let each of passwordLooper; let last = last"
        [class.last]="last"
        class="symbol"
        svgIcon="asterisk"
      />
    </div>
    <div
      (click)="togglePasswordVisibility()"
      class="suffix-icon-section bg-palo-verde rounded-full border border-[#1E282A] border-px box-border"
      matSuffix
    >
      <app-icon
        [svgIcon]="suffixIcon"
        class="suffix-icon"
      >
      </app-icon>
    </div>
    <mat-error *ngIf="error">{{ error }}</mat-error>
  </mat-form-field>
</div>
